import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../hooks/redux.hook";
import { authSelector } from "../../../app/features/auth/auth.slice";

import DashboardContent from "./Content";
import DashboardSidebar from "./Sidebar";
import DashboardFooter from "./Footer";
import { AppRoutes } from "../../../utils/mapping/appRoutes.mapping";
import { commonSelector } from "../../../app/features/common/common.slice";
import {
  sharedTicketsSelector,
  rxCloseModalTicketDetail,
  rxCloseModalTicketCancel,
  rxOpenModalTicketDetail,
  rxCloseModalTicketRejectAt,
  rxCloseModalTicketRejectAp,
  rxCloseModalTicketReassign,
  rxCloseModalTicketSolve,
} from "../../../app/features/sharedTickets/sharedTickets.slice";
import ModalAlert from "../../../components/global/ModalAlert";
import ModalConfirm from "../../../components/global/ModalConfirm";
import ModalTicketCancel from "../../pages/HelpDesk/Shared/ModalTicketCancel";
import ModalTicketDetail from "../../pages/HelpDesk/Shared/ModalTicketDetail";
import ModalTicketReassign from "../../pages/HelpDesk/Shared/ModalTicketReassign";
import ModalTicketRejectAp from "../../pages/HelpDesk/Shared/ModalTicketRejectAp";
import ModalTicketRejectAt from "../../pages/HelpDesk/Shared/ModalTicketRejectAt";
import ModalTicketSolve from "../../pages/HelpDesk/Shared/ModalTicketSolve";
import NextHelperStatus from "../../../components/next/NextHelperStatus";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { token } = useAppSelector(authSelector);
  const [validating, setValidating] = useState(true);
  const { modalAlert, modalConfirm } = useAppSelector(commonSelector);
  const { modalDetail, modalCancel, modalRejectAt, modalRejectAp, modalReassign, modalSolve } =
    useAppSelector(sharedTicketsSelector);

  const closeModalTicketDetail = () => dispatch(rxCloseModalTicketDetail());

  const closeModalCancel = () => {
    dispatch(rxCloseModalTicketCancel());
    dispatch(rxOpenModalTicketDetail());
  };

  const closeModalRejectAt = () => {
    dispatch(rxCloseModalTicketRejectAt());
    dispatch(rxOpenModalTicketDetail());
  };

  const closeModalRejectAp = () => {
    dispatch(rxCloseModalTicketRejectAp());
    dispatch(rxOpenModalTicketDetail());
  };

  const closeModalReassign = () => {
    dispatch(rxCloseModalTicketReassign());
    dispatch(rxOpenModalTicketDetail());
  };

  const closeModalSolve = () => {
    dispatch(rxCloseModalTicketSolve());
    dispatch(rxOpenModalTicketDetail());
  };

  useEffect(() => {
    if (!token) {
      navigate(AppRoutes.login, { replace: true });
    } else {
      setValidating(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="bg-white h-screen w-screen overflow-hidden">
      {validating && <div>Espere...</div>}
      {!validating && (
        <>
          <div className="flex">
            <DashboardSidebar />
            <DashboardContent />
          </div>
          <DashboardFooter />
          <NextHelperStatus />
          {modalAlert.isOpen && <ModalAlert />}
          {modalConfirm.isOpen && <ModalConfirm />}
          {modalDetail.isOpen && (
            <ModalTicketDetail
              isOpen={modalDetail.isOpen}
              onCloseModal={closeModalTicketDetail}
              tickets={modalDetail.dataRecord}
              action={modalDetail.action}
              title={modalDetail.title!}
            />
          )}
          {modalCancel.isOpen && (
            <ModalTicketCancel
              isOpen={modalCancel.isOpen}
              onCloseModal={closeModalCancel}
              ticket={modalCancel.dataRecord}
            />
          )}
          {modalRejectAt.isOpen && (
            <ModalTicketRejectAt
              isOpen={modalRejectAt.isOpen}
              onCloseModal={closeModalRejectAt}
              ticket={modalRejectAt.dataRecord}
            />
          )}
          {modalRejectAp.isOpen && (
            <ModalTicketRejectAp
              isOpen={modalRejectAp.isOpen}
              onCloseModal={closeModalRejectAp}
              ticket={modalRejectAp.dataRecord}
            />
          )}
          {modalReassign.isOpen && (
            <ModalTicketReassign
              isOpen={modalReassign.isOpen}
              onCloseModal={closeModalReassign}
              ticket={modalReassign.dataRecord}
            />
          )}
          {modalSolve.isOpen && (
            <ModalTicketSolve
              isOpen={modalSolve.isOpen}
              onCloseModal={closeModalSolve}
              ticket={modalSolve.dataRecord}
            />
          )}
        </>
      )}
    </div>
  );
};

export default DashboardLayout;
